<script>
export default {}
</script>

<template>
  <v-layout><slot /></v-layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
